import { ScannerLink } from "@/app/components/scanner-link"
import { DiscordIcon } from "@/app/icons/discord"
import { InstagramIcon } from "@/app/icons/instagram"
import { ScannerIcon } from "@/app/icons/scanner"
import { WebsiteIcon } from "@/app/icons/site"
import { XIcon } from "@/app/icons/x"
import type {
  CollectionScanner,
  SocialLinks,
} from "@anaconda/core/nft-collection/collection/types"
import { useLingui } from "@lingui/react/macro"
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@rarible_int/anaconda_ui_components"
interface Props {
  socialLinks: SocialLinks
  scanner?: CollectionScanner
}

type LinkType = keyof Required<SocialLinks>

const ICON_BY_LINK_TYPE: Record<
  LinkType,
  React.ComponentType<{ className?: string }>
> = {
  discord: DiscordIcon,
  instagram: InstagramIcon,
  twitter: XIcon,
  site: WebsiteIcon,
}

export function CollectionLinks(props: Props) {
  const socialLinks = Object.entries(props.socialLinks)
  const { t } = useLingui()

  if (!socialLinks.length && !props.scanner) {
    return null
  }

  return (
    <div className="flex items-center gap-2 text-foreground/60">
      {props.scanner && <ScannerLink url={props.scanner.url} />}
      {socialLinks.map(([type, url]) => {
        const Icon = ICON_BY_LINK_TYPE[type as LinkType]

        return (
          <Tooltip key={type} delayDuration={100}>
            <TooltipTrigger asChild>
              <a
                target="_blank"
                rel="noreferrer"
                href={url}
                className="flex h-5 items-center"
                title=""
              >
                <Icon />
              </a>
            </TooltipTrigger>
            <TooltipContent>
              {type === "site"
                ? "Website"
                : type.charAt(0).toUpperCase() + type.slice(1)}
            </TooltipContent>
          </Tooltip>
        )
      })}
    </div>
  )
}
